/* A repeatable Class to allow toggling of load-more classes on specified elements */

export default class LoadMore {
    /**
     * Creates an instance of LoadMore.
     *
     * @param {string} [parentClass='.parent'] - The selector for the parent element that contains both the load more and will load elements.
     * @param {string} [loadMoreButton='.load-more'] - The selector for the load more button.
     * @param {string} [itemsToLoad='.will-load'] - The selector for the elements to load.
     * @memberof LoadMore
     */

    constructor(parentClass, loadMoreButton = '.load-more', itemsToLoad = '.will-load') {
        this.loadMoreEls = document.querySelectorAll(loadMoreButton);
        this.itemsToLoad = itemsToLoad;
        this.parentClass = parentClass;
        this.bindEvents();
    }

    bindEvents() {
        this.loadMoreEls.forEach((el) => {

            const parent = el.closest(this.parentClass);
            const willLoadEls = parent.querySelectorAll(this.itemsToLoad);

            el.addEventListener('click', () => {

                willLoadEls.forEach((el) => {
                    el.classList.toggle('is-loaded');
                });

                const loadMoreText = el.textContent;
				el.classList.toggle('hide');
                el.textContent = loadMoreText === 'Show all' ? 'Hide' : 'Show all';
            });
        });
    }
}
